import { render, staticRenderFns } from "./customer-care.vue?vue&type=template&id=224a2edf&scoped=true"
import script from "./customer-care.vue?vue&type=script&lang=js"
export * from "./customer-care.vue?vue&type=script&lang=js"
import style0 from "./customer-care.vue?vue&type=style&index=0&id=224a2edf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224a2edf",
  null
  
)

export default component.exports